/**
 * @file 应用案例页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import Case from './Case';

import './style.less';



ReactDOM.render(<Case />, document.getElementById('root'));


